import { Stack } from '@chakra-ui/react'
import noop from 'lodash/noop'
import React from 'react'

import FormField from '../../components/FormField'
import Dependent from '../../components/FormField/Dependent'

const fields = [
  { name: 'name', label: '聯絡人', rules: { required: true } },
  { name: 'unit', options: ['單位/團隊', '個人'], type: 'radio', rules: { required: true } },
  { name: 'company', label: '單位/團隊名稱', rules: { required: true }, when: ['unit', '單位/團隊'] },
  { name: 'email', label: '信箱', type: 'email', rules: { required: true } },
  { name: 'phone', label: '電話' },
  { name: 'line_id', label: 'LINE ID' },
  { name: 'memo', label: '備註', type: 'textarea' },
]

const ContactInfo = ({ register = noop, control, errors }) => {
  return (
    <Stack px="2" spacing="3">
      {fields.map(({ name, type, label, helper, options, when, placeholder, ...config }) => {
        const render = (
          <FormField
            key={name}
            {...register(name, config)}
            type={type}
            label={label}
            helper={helper}
            options={options}
            control={control}
            errors={errors}
            placeholder={placeholder}
            {...config}
          />
        )
        return when && control ? <Dependent control={control} when={when}>{render}</Dependent> : render
      })}
    </Stack>
  )
}

export default ContactInfo
